export default __webpack_public_path__ + "static/media/rocket_anim_5.9f09771a.png";